module.exports = __webpack_public_path__ + "img/Allen Treadaway.304cffdf.jpg";